import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/api';
import { ArrowLeft } from '@phosphor-icons/react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card } from '../components/ui/card';
import { toast } from 'sonner';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/api/auth/forgot-password', { email });
      setSubmitted(true);
      toast.success('Richiesta inviata');
    } catch (error) {
      if (error.response?.status === 429) {
        toast.error('Troppe richieste. Riprova tra qualche minuto.');
      } else {
        toast.error("Errore durante l'invio");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <div className="px-4 pt-6">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-foreground/60 hover:text-primary transition-colors" data-testid="back-home-link">
          <ArrowLeft size={16} /> Torna alla home
        </Link>
      </div>
      <div className="flex items-center justify-center px-4 py-16">
        <Card className="w-full max-w-md p-8 neumorphism rounded-2xl" data-testid="forgot-password-form">
          <div className="text-center mb-8">
            <h1 className="font-heading font-semibold text-3xl text-foreground mb-2">
              Password dimenticata?
            </h1>
            <p className="text-foreground/70">
              Inserisci la tua email e ti invieremo un link per reimpostare la password.
            </p>
          </div>

          {submitted ? (
            <div className="text-center space-y-6" data-testid="forgot-password-success">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto">
                <span className="text-4xl">📧</span>
              </div>
              <p className="text-foreground/80">
                Se l'email <strong>{email}</strong> è registrata, riceverai a breve un link per reimpostare la password.
              </p>
              <p className="text-sm text-foreground/60">Il link è valido per 1 ora.</p>
              <Link to="/login">
                <Button variant="outline" className="rounded-full">Torna al login</Button>
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="mario.rossi@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  data-testid="forgot-email-input"
                />
              </div>

              <Button
                type="submit"
                className="w-full rounded-full"
                disabled={loading}
                data-testid="forgot-submit-btn"
              >
                {loading ? 'Invio in corso...' : 'Invia link di reset'}
              </Button>

              <div className="text-center">
                <Link to="/login" className="text-sm text-primary font-medium hover:underline">
                  Torna al login
                </Link>
              </div>
            </form>
          )}
        </Card>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
